export const TEXT_ON_POPUP_MIN_LENGTH = 3
export const TEXT_ON_POPUP_MAX_LENGTH = 200

export function stripHtml(html?: string): string {
  if (!html) return ''
  return html
    .replace(/<[^>]*>/g, '')
    .replace(/&(nbsp|ensp|emsp|#160);/gi, ' ')
    .trim()
}

export function validateTextOnPopup(value?: string) {
  const text = stripHtml(value)
  if (text.length < TEXT_ON_POPUP_MIN_LENGTH) {
    return 'Text on Pop Up must be at least 3 characters.'
  }
  return true
}
